import { css } from 'styled-components';
import { SELECT_FIELD_OPTION_LIST_GAP } from '../tokens/select-field';
import { getSelectOptionListHeight } from '../utils';
export const selectFieldControlZIndex = ({ optionsVisible, }) => (optionsVisible ? 10 : 1);
export const selectFieldFlyoutMaxWidth = ({ width, }) => (width ? `${width}px` : '100%');
export const selectFieldListHeight = ({ size = 10, }) => size
    ? css `
        max-height: ${getSelectOptionListHeight({ size })}px;
      `
    : null;
export const selectFieldOptionListGap = ({ allowMultiple, }) => allowMultiple
    ? SELECT_FIELD_OPTION_LIST_GAP.MULTIPLE
    : SELECT_FIELD_OPTION_LIST_GAP.DEFAULT;
